import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import HealthList from './components/HealthList';

const { Cell } = ResponsiveGrid;

const Health = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="身體量測列表"
        breadcrumbs={[
          {
            name: '身體量測',
          },
          {
            name: '身體量測列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <HealthList />
    </Cell>
  </ResponsiveGrid>
);

export default Health;
